<template>
    <div class="vx-card p-6">
        <div class="vx-row">
            <div class="vx-col">
                <h3>Thông tin lịch hẹn</h3>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label required">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false"
                          name="branch"
                          v-validate="'required'" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                <label class="vs-input--label required">Khách hàng</label>
                <v-select class="w-full" v-model="selectedCustomer" :options="customerOptions" :clearable="false"
                          name="customer" v-validate="'required'" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('customer') }}</span>
            </div>
            <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full mt-4">
                <label class="vs-input--label required">Ngày</label>
                <!-- <flat-pickr :config="configDatePicker" v-model="selectDate" class="w-full vs-inputx vs-input--input normal"
                    v-validate="'required'" name="time" /> -->
                <datepicker :highlighted="highlighted" class="w-full" id="searchDate" :language="vi"
                            :format="'dd/MM/yyyy'"
                            v-model="selectDate" data-vv-validate-on="input" ref="datepickBooking"
                            v-validate="'required'"
                            name="time" :disabled="(checkStatus === 3 || checkStatus === 4) && isUpdate">
                </datepicker>
                <span class="text-danger text-sm">{{ errors.first('time') }}</span>
            </div>
            <div class="vx-col lg:w-1/6 md:w-1/4 sm:w-1/2 w-full mt-4">
                <label class="vs-input--label required">Giờ</label>
                <flat-pickr :config="configTimePicker" v-model="selectTime"
                            class="w-full vs-inputx vs-input--input normal"
                            name="time" v-validate="'required'"
                            :disabled="(checkStatus === 3 || checkStatus === 4) && isUpdate"/>
                <span class="text-danger text-sm">{{ errors.first('time') }}</span>
            </div>
            <div class="vx-col lg:w-1/4 sm:w-1/2 w-full mt-4" v-if="isUpdate">
                <label class="vs-input--label">Trạng thái</label>
                <v-select class="w-full" v-model="selectedStatus" :options="statusCreateOptions"
                          :clearable="false"
                          :disabled="(checkStatus === 3 || checkStatus === 4) && isUpdate"></v-select>
            </div>
            <div class="vx-col lg:w-3/4 md:w-full sm:w-1/2 w-full mt-4" v-if="isUpdate && selectedStatusValue === 4">
                <label class="vs-input--label">Lý do hủy</label>
                <vs-textarea class="w-full" v-model="cancelReason" :disabled="checkStatus === 4 && isUpdate"/>
            </div>
            <div class="vx-col w-full mt-6">
                <vs-radio v-model="packageType" vs-value="1" class="mr-4" @change="changeSelectType"
                          :disabled="isUpdate">Nhóm dịch vụ
                </vs-radio>
                <vs-radio v-model="packageType" vs-value="2" @change="changeSelectType" :disabled="isUpdate">Gói
                    dịch vụ
                </vs-radio>
            </div>
            <div class="vx-col w-full">
                <div class="vx-row" v-if="packageType == 1">
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                        <label class="vs-input--label required">Nhóm dịch vụ</label>
                        <v-select class="w-full" v-model="selectedBeautyService" :options="beautyServiceOptions"
                                  :clearable="false" name="beautySevice" :disabled="isUpdate">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                        <label class="vs-input--label required">Dịch vụ</label>
                        <v-select class="w-full" v-model="selectedBeautyServicePack" :options="beautyServicePackOptions"
                                  :clearable="false" name="beautySevicePack" :disabled="isUpdate">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                    <div class="vx-col lg:w-1/3 md:w-1/2 sm:w-1/2 w-full mt-4">
                        <label class="vs-input--label">Bác sĩ</label>
                        <v-select class="w-full" v-model="selectedDoctor" :options="doctorOptions" :clearable="false"
                                  name="beautySevicePack"
                                  :disabled="(checkStatus === 3 || checkStatus === 4) && isUpdate">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>
                <div class="vx-row" v-if="packageType == 2">
                    <div class="vx-col lg:w-1/3 md:w-1/2 w-full mt-4">
                        <label class="vs-input--label required">Gói dịch vụ</label>
                        <v-select class="w-full" v-model="selectedBeautyServiceCombo"
                                  :options="beautyServiceComboOptions"
                                  :clearable="false" name="beautySevice" :disabled="isUpdate">
                            <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                        </v-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="vx-col lg:w-full md:w-full sm:w-full w-full mt-4" >
                <label class="vs-input--label">Ghi chú</label>
                <vs-textarea v-model="note" class="w-full" />
            </div>

        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <div class="flex float-right">
                    <vs-button class="mr-2" color="primary" iconPack="feather" icon="icon-check" @click="saveData"
                               :disabled="!validateForm || ((checkStatus === 3 || checkStatus === 4) && isUpdate)"
                               v-if="(isUpdate && isPermissionUpdateBooking) || (!isUpdate && isPermissionCreateBooking)">
                        {{ isUpdate ? 'Cập nhật' : 'Tạo mới' }}
                    </vs-button>
                    <!-- <vs-button class="" color="warning" type="border" iconPack="feather" icon="icon-corner-up-left"
                               @click="$router.push('/user/booking-customers')">Quay lại
                    </vs-button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
// import moment from 'moment';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
// import {Vietnamese} from 'flatpickr/dist/l10n/vn';
import Datepicker from 'vuejs-datepicker';
import {en, vi} from 'vuejs-datepicker/dist/locale';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {

    components: {
        vSelect,
        flatPickr,
        Datepicker
    },

    props: {
        bookingId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            branchOptions: [],
            customerOptions: [],
            selectedBranchValue: null,
            selectedCustomerValue: null,
            selectDate: new Date(),
            selectTime: new Date(),
            // configDatePicker: {
            //     dateFormat: 'Z',
            //     defaultDate: new Date(),
            //     locale: Vietnamese,
            //     altFormat: 'd-m-Y',
            //     altInput: true,
            //     wrap: true,
            //     allowInput: true,
            // },
            configTimePicker: {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                time_24hr: true,
                // minTime: "07:00",
            },
            packageType: '1',
            beautyServiceOptions: [],
            beautyServicePackData: [],
            beautyServiceComboData: [],
            beautyServicePackOptions: [],
            selectedBeautyServiceValue: null,
            selectedBeautyServicePackValue: null,
            doctorOptions: [],
            selectedDoctorValue: null,
            beautyServiceComboOptions: [],
            selectedBeautyServiceComboValue: null,
            selectedDepartmentValue: null,
            isUpdate: false,
            idBeautyBooking: null,
            idBeautyBookingDetails: null,
            statusOptions: [
                {value: 1, label: 'Chờ xử lý'},
                {value: 2, label: 'Xác nhận'},
                {value: 3, label: 'Hoàn thành'},
                {value: 4, label: 'Hủy'},
            ],
            selectedStatusValue: null,
            cancelReason: null,
            note:null,
            en: en,
            vi: vi,
            highlighted: {
                dates: [
                    new Date()
                ]
            },
            statusCreateOptions: [],
            checkStatus: false,
        }
    },

    computed: {
        selectedBranch: {
            get() {
                let obj = this.branchOptions.find(x => x.value === this.selectedBranchValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                if (this.packageType == 1) this.getBeautyService();
                if (this.packageType == 2) this.getBeautyServiceCombo();
            }
        },

        selectedCustomer: {
            get() {
                let obj = this.customerOptions.find(x => x.value === this.selectedCustomerValue);
                console.log(obj);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedCustomerValue = obj ? obj.value : null;
            }
        },

        selectedBeautyService: {
            get() {
                let obj = this.beautyServiceOptions.find(x => x.value === this.selectedBeautyServiceValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyServiceValue = obj ? obj.value : null;
                this.getBeautyServicePack();
            }
        },

        selectedBeautyServicePack: {
            get() {
                let obj = this.beautyServicePackOptions.find(x => x.value === this.selectedBeautyServicePackValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyServicePackValue = obj ? obj.value : null;
                this.selectedDepartmentValue = obj ? obj.departmentId : null;
                this.getDoctor()
            }
        },

        selectedDoctor: {
            get() {
                let obj = this.doctorOptions.find(x => x.value === this.selectedDoctorValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedDoctorValue = obj ? obj.value : null;
            }
        },

        selectedBeautyServiceCombo: {
            get() {
                let obj = this.beautyServiceComboOptions.find(x => x.value === this.selectedBeautyServiceComboValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedBeautyServiceComboValue = obj ? obj.value : null;
            }
        },

        selectedStatus: {
            get() {
                let obj = this.statusCreateOptions.find(x => x.value === this.selectedStatusValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            set(obj) {
                this.selectedStatusValue = obj ? obj.value : null;
            }
        },

        validateForm() {
            return !this.errors.any()
        },
    },

    watch: {},

    created() {
        let check = false;
        this.$eventBus.$on("notify-detail-beauty-booking", ($event) => {
            if ($event) this.initScreen();
            check = true;
        })
        if (!check) this.initScreen();
    },

    methods: {
        async initScreen() {
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            this.branchOptions = branchList.map(x => {
                return {label: x.organizationBranchName, value: x.id}
            });

            this.statusCreateOptions = this.statusOptions;

            let id = this.$route.query.id ? this.$route.query.id : this.$route.query.beautyBookingId ? this.$route.query.beautyBookingId : this.bookingId;
            if (id) {
                this.isUpdate = true;
                this.idBeautyBooking = parseInt(id);
                this.getDetails(this.idBeautyBooking)
            }

            if (!this.isUpdate) await this.getCustomer();
        },
        changeSelectType() {
            if (this.selectedBranchValue && this.packageType == 1) {
                this.selectedBeautyServiceComboValue = null;
                this.getBeautyService();
            }
            if (this.selectedBranchValue && this.packageType == 2) {
                this.selectedBeautyServiceValue = null;
                this.selectedBeautyServicePackValue = null;
                this.selectedDoctorValue = null;
                this.getBeautyServiceCombo();
            }
        },

        getCustomer(dataCustomer) {
            return new Promise((resolve, reject) => {
                this.customerOptions = [];

                let url = `/loyalty/customer/find?keySearch=${dataCustomer.fullName}`
                this.$vs.loading();
                this.$crm.get(url).then(res => {
                    console.log(res)
                    if (res.data.content && res.data.content.length > 0) {
                        this.customerOptions = res.data.content.map(el => {
                            return {
                                value: el.id,
                                label: el.phoneNumber + ' - ' + el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        getBeautyService(dataService, organizationBranchId) {
            return new Promise((resolve, reject) => {
                this.beautyServiceOptions = [];
                let payload = {
                    organizationBranchId: !this.isUpdate ? this.selectedBranchValue : organizationBranchId,
                    keySearch: dataService ? dataService.beautyService.name : null,
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service/find-by-condition', payload).then(res => {
                    res.data.content.map(x => {
                        let data = this.beautyServiceOptions.find(t => t.value === x.id);
                        if (!data) {
                            let result = {
                                value: x.id,
                                label: x.code + '-' + x.name,
                            }
                            this.beautyServiceOptions.push(result);
                        }
                    })
                    this.beautyServiceOptions = Array.from(new Set(this.beautyServiceOptions));
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getBeautyServicePack() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                let payload = {
                    organizationBranchId: this.selectedBranchValue,
                    beautyServiceId: this.selectedBeautyServiceValue,
                    active: this.isUpdate ? -1 : null,
                };
                this.$crm.post('beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackOptions = res.data.content.map(el => {
                        return {
                            value: el.beautyServicePackage.id,
                            label: el.beautyServicePackage.code + '-' + el.beautyServicePackage.name,
                            departmentId: el.beautyServicePackage.departmentId,
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getBeautyServiceCombo() {
            return new Promise((resolve, reject) => {
                this.beautyServiceComboOptions = [];
                this.$crm.post('/beauty-package-combo/find-by-condition', {organizationBranchId: this.selectedBranchValue}).then(res => {
                    if (res.data.content && res.data.content.length > 0) {
                        this.beautyServiceComboOptions = res.data.content.map(x => {
                            return {
                                label: x.code + '-' + x.name,
                                value: x.id
                            };
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDoctor() {
            return new Promise((resolve, reject) => {
                this.doctorOptions = [];
                this.$vs.loading();

                let url = '/beauty-booking/get-list-doctor-department?';
                if (this.selectedBranchValue) {
                    url += `organizationBranchId=${this.selectedBranchValue}`;
                }
                if (this.selectedDepartmentValue) {
                    url += `&departmentId=${this.selectedDepartmentValue}`;
                }

                this.$crm.get(url).then(res => {
                    if (res.data.data && res.data.data.length > 0) {
                        this.doctorOptions = res.data.data.map(el => {
                            return {
                                value: el.id,
                                label: el.fullName
                            }
                        });
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch(err => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getDetails(id) {
            this.$vs.loading();
            this.$crm.get(`/beauty-booking/find-by-id/${id}`).then(async res => {
                this.selectedBranchValue = res.data.organizationBranchId;
                await this.getCustomer(res.data.loyaltyCustomer);
                this.selectedCustomerValue = res.data.loyaltyCustomer.id;
                let result = res.data.beautyBookingDetails.find(x => x.beautyBooking.id === id);
                this.selectedStatusValue = res.data.status;
                this.checkStatus = res.data.status;
                this.note = res.data.note;
                if (this.selectedStatusValue === 1) {
                    this.statusCreateOptions = this.statusOptions.filter(x => x.value !== 3);
                } else if (this.selectedStatusValue === 2) {
                    this.statusCreateOptions = this.statusOptions.filter(x => x.value !== 1);
                } else if (this.selectedStatusValue === 3) {
                    this.statusCreateOptions = this.statusOptions.filter(x => x.value === 3);
                } else if (this.selectedStatusValue === 4) {
                    this.statusCreateOptions = this.statusOptions.filter(x => x.value === 4);
                }
                this.idBeautyBookingDetails = result.id;
                this.packageType = res.data.packageType;
                this.cancelReason = res.data.cancelReason;
                if (this.packageType == 1) {
                    await this.getBeautyService(res.data.beautyBookingDetails[0], res.data.organizationBranchId);
                    this.selectedBeautyServiceValue = result ? result.beautyService.id : null;
                    await this.getBeautyServicePack();
                    this.selectedBeautyServicePackValue = result ? result.beautyServicePackage.id : null;

                    // if (this.beautyServicePackOptions.length > 0) {
                    //     let department = this.beautyServicePackOptions.find(x => x.value == this.selectedBeautyServicePackValue);
                    //     this.selectedDepartmentValue = department ? department.departmentId : null;
                    await this.getDoctor();
                    this.selectedDoctorValue = result ? result.performerId : null;
                    // }
                    // this.selectedDepartmentValue = this.beautyServicePackOptions.find(x => x.value == this.selectedBeautyServicePackValue).departmentId;
                    // await this.getDoctor();
                    // this.selectedDoctorValue = result ? result.performerId : null;
                }

                if (this.packageType == 2) {
                    await this.getBeautyServiceCombo();
                    this.selectedBeautyServiceComboValue = result.beautyPackageCombo.id;
                }

                this.selectDate = result ? result.bookingDate : null;
                this.selectTime = result.startTime ? result.startTime : null;
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        async saveData(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            if (this.packageType == 1 && !this.selectedBeautyServicePackValue) {
                return this.$vs.notify({
                    text: 'Dịch vụ chỉ tiêu là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (this.packageType == 2 && !this.selectedBeautyServiceComboValue) {
                return this.$vs.notify({
                    text: 'Gói dịch vụ là trường bắt buộc!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }

            let url = '/beauty-booking/';
            if (!this.isUpdate) {
                url += 'create';
                let checkDate = new Date(new Date(this.selectDate).setHours(parseInt(this.selectTime.substr(0, 2)), parseInt(this.selectTime.substr(3, 2)), 0));
                if (checkDate < new Date()) {
                    return this.$vs.notify({
                        text: 'Thời gian đặt lịch không hợp lệ!',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
            }
            if (this.isUpdate && this.selectedStatusValue === 1) {
                return this.$vs.notify({
                    text: 'Phải thay đổi trạng thái trước khi cập nhật!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            if (this.isUpdate && this.selectedStatusValue === 2) {
                url += 'confirm-booking';
            }
            if (this.isUpdate && this.selectedStatusValue === 3) {
                url += 'complete-booking';
            }
            if (this.isUpdate && this.selectedStatusValue === 4) {
                url += 'cancel-booking';
            }

            let payload = {
                organizationBranchId: this.selectedBranchValue,
                loyaltyCustomerId: this.selectedCustomerValue,
                isDoctorCreate: true,
                packageType: this.packageType,
                id: this.idBeautyBooking,
                cancelReason: this.cancelReason,
                note:this.note,
                beautyBookingDetails: [
                    {
                        beautyServicePackageId: this.selectedBeautyServicePackValue,
                        bookingDate: new Date(new Date(this.selectDate).setUTCHours(0, 0, 0, 0)).toISOString(),
                        performerId: this.selectedDoctorValue,
                        startTime: this.selectTime,
                        beautyPackageComboId: this.selectedBeautyServiceComboValue,
                        id: this.idBeautyBookingDetails,
                    }
                ]
            };

            this.$vs.loading();
            this.$crm.post(url, payload).then(() => {
                this.$vs.notify({
                    text: `Tạo mới lịch hẹn thành công!'`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$store.commit('SET_BOOKING_POPUP', false); 
                this.$vs.loading.close();
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        isPermissionCreateBooking() {
            return isAPI(this, constAPI.beauty_booking_create);
        },

        isPermissionUpdateBooking() {
            return isAPI(this, constAPI.beauty_booking_update);
        },
    }
}
</script>

<style>
.required:after {
    content: " *";
    color: red;
}
</style>
